import React, { useEffect, useState } from "react";
import "./HeroAnimated.css";
import bg1video from '../images/bg1video.mp4'

const HeroAnimated = ({content}) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % content.data.length);
    }, 3000); // change line every 3sec
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative w-full py-20 overflow-hidden">
      
      {/* 🔹 Background Video */}
      <video
        autoPlay
        loop
        muted
        className="absolute top-0 left-0 w-full h-full object-cover opacity-100"
      >
        <source src={bg1video} type="video/mp4" />
      </video>

      {/* 🔹 Dark overlay */}
      <div className="absolute top-0 left-0 w-full h-full bg-black/50"></div>

      {/* 🔹 Center Content */}
      <div className="relative z-10 h-full flex flex-col justify-center items-center text-center px-4">
        <h1 key={index}  className="text-4xl md:text-6xl font-semibold tracking-widest text-yellow-500 animated-text">
          {content.data[index]}
        </h1>
        <h3 className="text-yellow-500 mt-16 text-3xl">Start your journey with unipro world</h3>
      </div>
    </div>
  );
};

export default HeroAnimated;
